<template>
   <div class="hotel-order-detail-inner-section voucher-room-type-wrapper">
      <div class="voucher-room-type-inner">
         <div class="room-type-table-wrapper">
            <h4 class="voucher-and-room-title">{{ $t("orderDetail_lblRoomInformations") }}</h4>
            <div class="room-type-table-inner">
               <div class="room-type-item" v-for="(roomTypeItem, index) in roomType" :key="index">
                  <div class="room-type-field">
                     <span class="item-label">{{ $t("orderDetail_lblRoomType") }}</span>
                     <span class="item-value masked">{{ roomTypeItem.channelRoomName }}</span>
                  </div>

                  <div class="room-type-field">
                     <span class="item-label">{{ $t("orderDetail_lblAdultCount") }}</span>
                     <span class="item-value masked">{{ roomTypeItem.adultCount }}</span>
                  </div>

                  <div class="room-type-field">
                     <span class="item-label">{{ $t("orderDetail_lblChildCount") }}</span>
                     <span class="item-value masked">{{ roomTypeItem.childCount !== 0 ? roomTypeItem.childCount : "-" }}</span>
                  </div>

                  <div class="room-type-field">
                     <span class="item-label">{{ $t("orderDetail_lblChildAges") }}</span>
                     <span class="item-value masked">
                        <span v-for="(age, ageIndex) in roomTypeItem.childAges" :key="ageIndex" v-html="`${age}${ageIndex + 1 != roomTypeItem.childAges.length ? ',' : ''}`"></span>
                     </span>
                  </div>

                  <div class="room-type-field">
                     <span class="item-label">{{ $t("orderDetail_lblBoardType") }}</span>
                     <span class="item-value masked">{{ roomTypeItem.boardTypeName != null ? roomTypeItem.boardTypeName : "-" }}</span>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   name: "VoucherAndRoomInformationRoomType",
   props: {
      roomTypeSummary: { type: Array },
   },
   data() {
      return {
         roomType: [],
      };
   },
   created() {
      const self = this;
      self.roomType = this.roomTypeSummary;
   },
   watch: {
      roomTypeSummary: {
         handler: function (newRoomTypeSummary) {
            const self = this;
            self.roomType = newRoomTypeSummary;
         },
         deep: true,
      },
   },
};
</script>

<style lang="scss" scoped>
.voucher-room-type-wrapper {
   margin-top: 24px;
   .voucher-room-type-inner {
      .room-type-table-wrapper {
         .voucher-and-room-title {
            margin-bottom: 24px;
            font-weight: 600;
         }
         .room-type-table-inner {
            border: 1px solid var(--gray-300);
            border-radius: 10px;
            overflow: hidden;

            .room-type-item {
               display: grid;
               grid-template-columns: repeat(5, 1fr);

               &:not(:last-child) {
                  border-bottom: 1px solid var(--gray-300);
               }

               .room-type-field {
                  display: grid;
                  grid-template-rows: auto 1fr;
                  border-right: 1px solid var(--gray-300);

                  &:last-child {
                     border-right: none;
                  }

                  .item-label {
                     font-size: 14px;
                     color: var(--gray-700);
                     background-color: var(--gray-200);
                     padding: 16px;
                     border-bottom: 1px solid var(--gray-300);
                  }

                  .item-value {
                     font-size: 16px;
                     font-weight: 700;
                     word-break: break-word;
                     background-color: white;
                     padding: 16px;
                  }
               }

               &:first-child {
                  .room-type-field {
                     .item-label {
                        background-color: var(--gray-200);
                     }
                  }
               }

               &:not(:first-child) {
                  .room-type-field {
                     .item-label {
                        display: none;
                     }
                     grid-template-rows: 1fr;
                  }
               }
            }
         }

         @media (max-width: 767.98px) {
            .room-type-table-inner {
               .room-type-item {
                  grid-template-columns: 1fr;
                  border-radius: 10px;
                  margin-bottom: 16px;
                  border: 1px solid var(--gray-300);

                  &:last-child {
                     margin-bottom: 0;
                  }

                  &:not(:last-child) {
                     border-bottom: 1px solid var(--gray-300);
                  }

                  &:not(:first-child) {
                     .room-type-field {
                        .item-label {
                           display: block;
                        }
                        grid-template-rows: auto 1fr;
                     }
                  }

                  .room-type-field {
                     border-right: none;
                     border-bottom: 1px solid var(--gray-300);

                     &:last-child {
                        border-bottom: none;
                     }

                     .item-label {
                        padding: 12px 16px;
                     }

                     .item-value {
                        padding: 12px 16px;
                     }
                  }
               }
            }
         }
      }
   }
}
</style>
